import { render, staticRenderFns } from "./edit_leads.vue?vue&type=template&id=38f41d77&scoped=true"
import script from "./edit_leads.vue?vue&type=script&lang=js"
export * from "./edit_leads.vue?vue&type=script&lang=js"
import style0 from "./edit_leads.vue?vue&type=style&index=0&id=38f41d77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f41d77",
  null
  
)

export default component.exports